
<div class="v-flex w-100">
    <div class="w-100 mr-1">
        <f-read-only-field
            label = "Budgetierte Maßnahme/Nachrüstung"
            :value = "value"
            filled
            dense
        />
    </div>
    <v-menu
        v-if="edit"
        offset-y
    >
        <template v-slot:activator="{ attrs, on }">
            <a
                v-bind="attrs"
                v-on="on"
            >
                <v-icon size="24" color="primary" class="pt-5">mdi-plus</v-icon>
            </a>
        </template>

        <v-list>
            <!--
            <v-list-item link>
                <v-list-item-title>Event 1</v-list-item-title>
            </v-list-item>
            <v-list-item link>
                <v-list-item-title>Event 2</v-list-item-title>
            </v-list-item>
            -->
        </v-list>
    </v-menu>
    <div v-if="!edit">
        <v-icon size="24" color="primary" class="pt-5">mdi-open-in-app</v-icon>
    </div>
</div>
